const JARGON_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bhrData_repaired\b/gi, 'tracciato riparato'],
  [/\bhrData\b/gi, 'tracciato originale'],
  [/\bvalidDataPercentByFeature\b/gi, 'copertura dati per variabile'],
  [/\bafterAlignment\b/gi, 'dopo allineamento'],
  [/\bafterDedup\b/gi, 'dopo deduplicazione'],
  [/\bafterGapHandling\b/gi, 'dopo gestione gap'],
  [/\binterpolatedPoints\b/gi, 'punti interpolati'],
  [/\bduplicatesRemoved\b/gi, 'duplicati rimossi'],
  [/\bsevereGaps\b/gi, 'gap gravi'],
  [/\bcompromised\s*=\s*false\b/gi, 'non compromessi'],
  [/\bcompromised\s*=\s*true\b/gi, 'compromessi'],
  [/\bvalid\s*=\s*true\b/gi, 'validi'],
  [/\bvalid\s*=\s*false\b/gi, 'non validi'],
  [/\bbaseline\b/gi, 'pre-VR'],
  [/\bexposure\b/gi, 'post-VR'],
  [/\bnfft\s*=\s*512\b/gi, 'FFT a 512 punti'],
  [/\bforward-backward\b/gi, 'applicazione forward-backward'],
  [/\bWelch\b/g, 'Welch'],
  [/\bButterworth\b/g, 'Butterworth'],
  [/\bmetadata\b/gi, 'parametri registrati'],
  [/\bcheck deterministici locali\b/gi, 'controlli numerici'],
  [/\bpreprocessing\/spettrali\b/gi, 'preprocessing e analisi spettrale'],
  [/\bNormalizzazione spettrale\b/g, 'normalizzazione spettrale'],
  [
    /\bpipeline Normalizzazione spettrale\b/gi,
    'pipeline di normalizzazione spettrale',
  ],
  [/\bPSD\b/g, 'densità spettrale di potenza (PSD)'],
  [/\bLF\/HF\b/g, 'rapporto LF/HF'],
];

const trimRepeatedSpaces = (value: string) =>
  value
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+([,.;])/g, '$1')
    .trim();

export const humanizeVerificationText = (value: string): string =>
  JARGON_REPLACEMENTS.reduce(
    (text, [pattern, replacement]) => text.replace(pattern, replacement),
    value
  );

export const formatVerificationSummary = (
  summary: string,
  options?: {
    deterministicPassed?: boolean;
    includedCount?: number;
  }
): string => {
  let text = humanizeVerificationText(summary);

  const looksLikeTechnicalAllPass =
    /coerent|conformi|controlli deterministici|pipeline/i.test(text);

  if (options?.deterministicPassed && looksLikeTechnicalAllPass) {
    text =
      options.includedCount && options.includedCount > 0
        ? `La pipeline di normalizzazione spettrale risulta coerente sulle ${options.includedCount} sessioni incluse. Tutti i controlli numerici sono stati superati; qualità del segnale, preprocessing e analisi spettrale risultano conformi al protocollo BECOME.`
        : `La pipeline di normalizzazione spettrale risulta coerente. Tutti i controlli numerici sono stati superati; qualità del segnale, preprocessing e analisi spettrale risultano conformi al protocollo BECOME.`;
  }

  return trimRepeatedSpaces(text);
};

export const formatVerificationFindings = (findings: string[]): string[] => {
  const formatted = findings
    .map(finding => trimRepeatedSpaces(humanizeVerificationText(finding)))
    .filter(Boolean);

  if (formatted.length === 0) {
    return [];
  }

  return formatted.slice(0, 6);
};

export const buildDeterministicChecksHeadline = (
  passed: number,
  total: number
): string => {
  if (passed === total) {
    return `Controlli numerici: tutti superati (${passed}/${total}).`;
  }
  return `Controlli numerici: ${passed}/${total} superati, ${total - passed} da rivedere.`;
};

export const buildAllChecksPassedMessage = (): string =>
  'Nessuna anomalia numerica rilevata su conteggi, delta temporali, segmenti pre/post VR e parametri spettrali.';
